import { hashIndex } from '@renderer/utils/hash-index'

// The category tones at three depths: the solid, a mid step and the subtle tint. Steps flip in dark
// mode, so the mid and subtle steps pair with their own ramp's text and hold contrast in both themes.
// Solids carry the text that clears them: yellow and teal take dark text, the rest white. Red,
// orange, green and blue stay out, since status owns them.
const BADGE_COLORS = [
  'bg-indigo text-on-indigo',
  'bg-teal text-on-teal',
  'bg-purple text-on-purple',
  'bg-yellow text-on-yellow',
  'bg-pink text-on-pink',
  'bg-brown text-on-brown',
  'bg-indigo-6 text-indigo-12',
  'bg-teal-6 text-teal-12',
  'bg-purple-6 text-purple-12',
  'bg-yellow-6 text-yellow-12',
  'bg-pink-6 text-pink-12',
  'bg-brown-6 text-brown-12',
  'bg-indigo-subtle text-indigo-subtle',
  'bg-teal-subtle text-teal-subtle',
  'bg-purple-subtle text-purple-subtle',
  'bg-yellow-subtle text-yellow-subtle',
  'bg-pink-subtle text-pink-subtle',
  'bg-brown-subtle text-brown-subtle',
] as const

const HUE_COUNT = 6

/** Deterministic background and text classes from a string — same input always produces the same color. */
function hashColor(str: string): string {
  return BADGE_COLORS[hashIndex(str, BADGE_COLORS.length)]
}

/**
 * `hashColor` for each string in a stacked row, except a badge whose hue matches its left neighbour's
 * moves on to the next hue at the same depth, so two touching avatars never read as one colour.
 */
function hashColors(strs: ReadonlyArray<string>): Array<string> {
  let previousHue = -1
  return strs.map((str) => {
    let index = hashIndex(str, BADGE_COLORS.length)
    if (index % HUE_COUNT === previousHue) {
      index = index - previousHue + ((previousHue + 1) % HUE_COUNT)
    }
    previousHue = index % HUE_COUNT
    return BADGE_COLORS[index]
  })
}

export { hashColor, hashColors, BADGE_COLORS }
